export default {
  title: {
    index: '招聘网站点数管理',
    history: '招聘网站点数管理-增减记录'
  },
  menu: {
    index: '招聘网站点数管理',
    history: '招聘网站点数管理-增减记录'
  },
  label: {
    companyName: '公司名称',
    companyID: '公司ID',
    allocatePoints: '剩余点数',
    purchasedJobsCount: '已购买职位',
    postingJobs: '已发布职位',
    surplusPoints: '剩余点数',
    activeJobs: '在线职位数',
    surplusPointsTitle: '{companyName}的积分余额:',
    purchaseDate: '日期',
    job: '职位',
    activity: '操作',
    points: '积分',
    note: '备注',
    purchased: '增加',
    allocated: '减少',
    all: '所有记录'
  },
  placeholder: {
    pointsInput: '请输入积分',
    notes: '备注（可选）'
  },
  btn: {
  },
  message: {
    pointsRequired: '积分必须大于0',
    maxCountGatherZero: '职位数量必须大于等于0',
    pointsNotEnough: '前程无忧的发布积分已用完，请联系你的管理员或者菁客客户成功顾问获取更多支持',
    countsNotEnough: '你已经在领英发布了{count}个职位，到达了上限，请联系你的管理员或者菁客客户成功顾问获取更多支持',
    pointsLessThanMillion: '积分必须小于一百万'
  }
}
